export default __webpack_public_path__ + "static/media/fastener-placement-square-rounded-front.acc22e25.webp";